import React from 'react';
import { LoginForm } from '../Component';
import '../CSS/login.css';

function Login() {
  return (
    <div className="container">
      <LoginForm />
    </div>
  );
}

export default Login;
